var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eden-pagination"},[_c('p',[_vm._v("Showing "+_vm._s(_vm.from + 1)+" - "+_vm._s(_vm.to)+" of "+_vm._s(_vm.total))]),_c('el-pagination',{attrs:{"page-size":_vm.pageSize,"background":"","layout":"prev, pager, next","total":_vm.total,"current-page":_vm.setCurrentPage},on:{"current-change":_vm.updateCurrentPage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }